import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerProfilePublishRepository } from 'application/repositorySchemas/IBuyerProfilePublishRepository';
import { type IBuyerProfilePublishClient } from 'interfaceAdapter/gatewaySchemas/IBuyerProfilePublishClient';

@injectable()
export class BuyerProfilePublishRepository implements IBuyerProfilePublishRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerProfilePublishClient')
        public readonly buyerProfilePublishClient: IBuyerProfilePublishClient,
    ) {}

    // TODO 型づけをサボっている
    public async post(buyer: any) {
        const { data, message } = await this.buyerProfilePublishClient.post({
            token: this.buyerUserToken.get() || '',
            buyer,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
